module.exports = __webpack_public_path__ + "img/35.193e1489.jpg";